import { languageMap } from "..";
import { bracketIndenting } from "./shared";

languageMap.cypher = bracketIndenting({ line: "//" })